module.exports = "<router-outlet>\n\t<div class=\"loader_overlay fullscreen\"  [hidden]=\"!showLoader\"  >\n\t\t<div class=\"loader_wrap\">\n\t\t\t<div class=\"loader\">\t\t\t\t\t\t\t\n\t            <div class='logo-and-panel__wrapper'  id=\"loader\">\n\t            </div>\t\t\t\t\t        \n\t\t\t</div>\t\t\t\n\t\t</div>\n\t</div>\n</router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main